import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import MainHeader from '../../components/MainHeader/MainHeader'
import MainFooter from '../../components/MainFooter/MainFooter'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_2, boxvar2_3, boxvar2_1 } from '../../main.js'

import '../../main.css'
import './Home.css'
import './MHome.css'

import hero_img from '../../assets/pictures/humanvectors/team-min-klein.webp'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowUpRightFromSquare, faHandHoldingHeart, faSliders, faUserPlus } from '@fortawesome/free-solid-svg-icons'

import Cookies from 'universal-cookie'

export default function Home() {

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    return (
        <div className='mainCon page' id='mainCon'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Helferzeit – Ehrenamt, einfach organisiert</title>
                <meta name="description" content="Helferzeit sammelt ehrenamtliche Helfer für Veranstaltungen an einem Ort: Events finden, Wunschdienste wählen – fertig." />
            </Helmet>

            <MainHeader selectedsite={""} />

            <main className='page-body'>
                {/* Hero */}
                <section className='hero container'>
                    <div className='hero-grid'>
                        <div className='hero-text'>
                            <div className='section-eyebrow'>Ehrenamt, einfach organisiert</div>
                            <motion.h1
                                variants={boxvar3}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: false, margin: "-50px" }}
                                className='hero-headline'
                            >
                                Hand in Hand <em>organisieren.</em>
                            </motion.h1>
                            <p>
                                Hier findest du Events, wählst Wunschdienste und planst Einsätze –
                                alles an einem Ort für Helfer und Organisationen.
                            </p>
                            <div className='hero-cta'>
                                <a href='/events/public' className='btn btn-primary btn-lg'>
                                    Events entdecken <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                                <a href={loggedin ? '/profil' : '/login'} className='btn btn-secondary btn-lg'>
                                    Für Organisationen
                                </a>
                            </div>
                        </div>
                        <motion.img
                            variants={boxvar1}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, margin: "-50px" }}
                            className='hero-img'
                            src={hero_img}
                            alt='Illustration eines Teams, das gemeinsam arbeitet'
                        />
                    </div>
                </section>

                {/* Hinweis: WebApp vs. Website */}
                <section className='home-site-strip'>
                    <div className='container home-site-strip-inner'>
                        <div className='home-site-strip-copy'>
                            <div className='section-eyebrow'>Zur Website</div>
                            <h2 className='home-site-strip-title'>Du bist in der WebApp</h2>
                            <p className='section-sub'>
                                Anmeldung, Wunschdienste und Verwaltung laufen hier in der App.
                                Wer Helferzeit erst kennenlernen möchte – Idee hinter dem Projekt,
                                aktuelle News oder Hilfe bei Fragen – wird auf der Website fündig:
                                dort gibt’s Überblick, Support und alles, was rund ums Ehrenamt
                                mit Helferzeit erzählt wird.
                            </p>
                        </div>
                        <a
                            href='https://www.helferzeit.de'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='btn btn-secondary'
                        >
                            Zur Website <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </a>
                    </div>
                </section>

                {/* 3-Wege-Auswahl */}
                <section className='container section'>
                    <div className='section-eyebrow'>Für wen bist du hier?</div>
                    <h2 className='section-title'>Dein Einstieg</h2>
                    <div className='grid grid-3' style={{ marginTop: '20px' }}>
                        <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card card-hover way-card'>
                                <div className='way-icon way-icon-success'>
                                    <FontAwesomeIcon icon={faHandHoldingHeart} />
                                </div>
                                <h3>Du bist Helfer</h3>
                                <p>Du möchtest bei einer Veranstaltung mithelfen? Finde öffentliche Events in deiner Nähe und melde dich in wenigen Minuten an.</p>
                                <a href='/events/public' className='btn btn-primary'>
                                    Öffentliche Events <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </motion.div>

                        <motion.div variants={boxvar2_2} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card card-hover way-card'>
                                <div className='way-icon way-icon-brand'>
                                    <FontAwesomeIcon icon={faSliders} />
                                </div>
                                <h3>Du bist Organisator</h3>
                                <p>Du planst Veranstaltungen und brauchst Unterstützung? Verwalte Events, Dienstpläne und Mailings an einem Ort.</p>
                                <a href={loggedin ? '/profil' : '/login'} className='btn btn-secondary'>
                                    {loggedin ? 'Zum Profil' : 'Zum Login'} <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </motion.div>

                        <motion.div variants={boxvar2_3} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card card-hover way-card'>
                                <div className='way-icon way-icon-accent'>
                                    <FontAwesomeIcon icon={faUserPlus} />
                                </div>
                                <h3>Neu bei Helferzeit?</h3>
                                <p>Erstelle jetzt dein Helferzeit-Konto – ganz ohne Event-Anmeldung. So meldest du dich später mit einem Klick zu Veranstaltungen an.</p>
                                <a href='/register' className='btn btn-secondary'>
                                    Jetzt registrieren <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </motion.div>
                    </div>
                </section>

                {/* So funktioniert's */}
                <section className='container section' style={{ paddingTop: '8px' }}>
                    <div className='section-eyebrow'>So funktioniert's</div>
                    <h2 className='section-title'>In drei Schritten dabei</h2>
                    <div className='steps' style={{ marginTop: '20px' }}>
                        <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card step-card'>
                                <div className='step-num'>1</div>
                                <div>
                                    <h4>Event finden</h4>
                                    <p>Öffentliche Events durchstöbern – mit Anmeldestatus auf einen Blick.</p>
                                </div>
                            </div>
                        </motion.div>
                        <motion.div variants={boxvar2_2} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card step-card'>
                                <div className='step-num'>2</div>
                                <div>
                                    <h4>Dienste wählen</h4>
                                    <p>Wunschdienste auswählen, Wartelisten transparent im Blick.</p>
                                </div>
                            </div>
                        </motion.div>
                        <motion.div variants={boxvar2_3} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card step-card'>
                                <div className='step-num'>3</div>
                                <div>
                                    <h4>Loslegen</h4>
                                    <p>Der Veranstalter plant dich ein – dein Dienstplan ist jederzeit einsehbar.</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </section>
            </main>

            <MainFooter />
        </div>
    )
}
